import _styled from "styled-components";
import React from 'react';
import { Check } from "./Check/Check";
import * as styles from "./BlocksHeader.styles";
export var BlocksHeader = function BlocksHeader(_ref) {
  var currency = _ref.currency,
    isSelected = _ref.isSelected,
    label = _ref.label,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    price = _ref.price,
    variant = _ref.variant;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.blocksHeaderWrapper
  }, variant === 'check' && /*#__PURE__*/React.createElement(Check, {
    currency: currency,
    isSelected: isSelected,
    label: label,
    onClick: onClick,
    onFocus: onFocus,
    price: price
  }));
};
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "BlocksHeader___StyledDiv",
  componentId: "sc-31um4y-0"
})(["", ""], function (p) {
  return p.$_css;
});